import React, { lazy, Suspense, useCallback } from 'react';
import Logo from '../components/Logo/Logo';
import ScrollIndicator from '../components/ScrollIndicator/ScrollIndicator';
import ScrollProgressBar from '../components/ScrollProgressBar/ScrollProgressBar';
import ScrollHeader from '../components/ScrollHeader/ScrollHeader';
import AboutSection, { StatsSection } from '../components/AboutSection/AboutSection';
import useScrollProgress from '../hooks/useScrollProgress';
import './Home.css';

const ResumeXRaysSection = lazy(() => import('../components/ResumeXRaysSection/ResumeXRaysSection'));
const ResumeSection = lazy(() => import('../components/ResumeSection/ResumeSection'));
const ContactSection = lazy(() => import('../components/ContactSection/ContactSection'));

const BackToTop = ({ visible, scrollContentRef }) => {
  const scrollToTop = useCallback(() => {
    if (!scrollContentRef.current) return;
    scrollContentRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [scrollContentRef]);

  return (
    <button
      className={`back-to-top ${visible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Back to top"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8 13V3M8 3L3 8M8 3l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
};

const Home = () => {
  const { scrollContentRef, progressBarRef, headerVisible, backToTopVisible } = useScrollProgress();

  return (
    <>
      <div className="static-hero">
        <Logo />
        <ScrollIndicator />
      </div>
      <div className="scroll-content" ref={scrollContentRef}>
        <div className={`sticky-header-wrap ${headerVisible ? 'header-visible' : ''}`}>
          <ScrollProgressBar ref={progressBarRef} />
          <ScrollHeader />
        </div>
        <AboutSection />
        <StatsSection />
        <Suspense fallback={null}>
          <ResumeXRaysSection />
          <ResumeSection />
          <ContactSection />
        </Suspense>
      </div>
      <BackToTop visible={backToTopVisible} scrollContentRef={scrollContentRef} />
    </>
  );
};

export default Home;
